import { Database } from "lucide-react";
import SettingsSection from "./SettingsSection";

const retentionOptions = [
  "7 days",
  "14 days",
  "30 days",
  "60 days",
  "90 days",
  "1 year"
];

export default function DataRetentionSection({ dataRetention, onChange }) {
  return (
    <SettingsSection
      icon={Database}
      title="Data Retention"
      description="Configure data storage and retention policies"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Activity Log Retention
          </label>
          <select
            value={dataRetention.activityLog}
            onChange={(e) => onChange("activityLog", e.target.value)}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg bg-white text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {retentionOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Webhook Event Retention
          </label>
          <select
            value={dataRetention.webhookEvents}
            onChange={(e) => onChange("webhookEvents", e.target.value)}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg bg-white text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {retentionOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </SettingsSection>
  );
}
